"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mountIntegrationsOnboarding = void 0;
var react_1 = __importDefault(require("react"));
var luxon_1 = require("luxon");
var mobx_react_1 = require("mobx-react");
var inversify_react_1 = require("inversify-react");
var InlineOnboarding_1 = __importDefault(require("InlineOnboarding/InlineOnboarding"));
var PromptTypes_1 = require("@CommonFrontend/Prompt/PromptTypes");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var Tour_1 = require("@CommonFrontendBackend/Tour");
var integrationsOnboardingReleaseDate = "2022-10-17T00:00:00.000Z";
var IntegrationsOnboarding = (0, mobx_react_1.observer)(function () {
    var _a;
    var rootDataStore = (0, inversify_react_1.useInjection)("rootDataStore");
    var userDataStore = rootDataStore.userDataStore;
    var accountDataStore = rootDataStore.getAccountDataStore();
    var tourOrchestrator = (0, inversify_react_1.useInjection)("tourOrchestrator");
    var userCreatedAfterIntegrationsOnboardingRelease = luxon_1.DateTime.fromISO(userDataStore.createdAt) > luxon_1.DateTime.fromISO(integrationsOnboardingReleaseDate);
    var crmTechnologyIsHubspot = (_a = accountDataStore.census.crmTechnology) === null || _a === void 0 ? void 0 : _a.includes("hubspot");
    var hubspotIsEnabled = accountDataStore.integrations.hubspot.enabled;
    var showPanel = userCreatedAfterIntegrationsOnboardingRelease && (crmTechnologyIsHubspot || hubspotIsEnabled);
    var userCanWatchTour = userDataStore.isAdmin || tourOrchestrator.tours.automationHubspot.enabled;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(InlineOnboarding_1.default, { title: "Connect your CRM", description: userCanWatchTour ? (react_1.default.createElement(react_1.default.Fragment, null,
                "Connect Qwilr with Hubspot and start automating your pages.",
                " ",
                react_1.default.createElement(kaleidoscope_1.Link, { href: "https://help.qwilr.com/article/120-hubspot-integration" }, "View the guide"),
                " for more details.")) : (react_1.default.createElement(react_1.default.Fragment, null,
                "Automate your pages with HubSpot. Talk to your account admin about enabling the HubSpot integration or",
                " ",
                react_1.default.createElement(kaleidoscope_1.Link, { href: "https://help.qwilr.com/article/120-hubspot-integration" }, "view the guide"),
                " for more details.")), enabled: showPanel, promptId: PromptTypes_1.PromptId.IntegrationsHubspotOnboarding, tourId: userCanWatchTour ? Tour_1.TourId.AutomationHubspot : undefined, video: {
                videoSrc: "https://stock-videos.qwilr.com/onboarding/integrations-hubspot-overview.mp4",
                videoThumbnail: "integrations-onboarding-hubspot-thumb.png",
            } })));
});
var mountIntegrationsOnboarding = function (mountReactComponent) {
    return mountReactComponent(react_1.default.createElement(IntegrationsOnboarding, null));
};
exports.mountIntegrationsOnboarding = mountIntegrationsOnboarding;
exports.default = IntegrationsOnboarding;
